export function calculateColumnTotal(data, columnName) {
  let total = 0;

  data.forEach((row) => {
    const columnValue = parseFloat(row[columnName]);
    total += isNaN(columnValue) ? 0 : columnValue;
  });

  return total;
}

/** Pump UI decimal places (0–8). DB/API keep full precision (up to 8). Default 4. */
export const getDecimalPlaces = () => {
  const n = parseInt(localStorage.getItem("DecimalPlaces"), 10);
  if (!Number.isFinite(n) || n < 0 || n > 8) {
    return 4;
  }
  return n;
};

export const setDecimalPlacesLocal = (places) => {
  const n = parseInt(places, 10);
  const value = !Number.isFinite(n) || n < 0 || n > 8 ? 4 : n;
  localStorage.setItem("DecimalPlaces", String(value));
  return value;
};

/**
 * Formats numbers using the pump DecimalPlaces setting.
 * Optional second arg is ignored so screens/reports stay consistent with the setting.
 */
export const NumberFormat = (value, _pointIgnored) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const point = getDecimalPlaces();
  const formattedNumber = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: point,
    maximumFractionDigits: point,
  }).format(value);

  return formattedNumber;
};

export const RenderHTMLStringWithoutDiv = (htmlString) => {
  return (
    <table className="add-render-table">
      <tbody dangerouslySetInnerHTML={{ __html: htmlString }} />
    </table>
  );
};
